import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as common from '../../../../common'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.Scenario.Updates,
    graphql.schema.ScenarioUpdates
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    variables: common.gql.dms.data.inputs.variableValue.TRANSFORMER,
    visibility: common.gql.admin.scenario.enums.scenarioVisibility.TRANSFORMER,
  }),
)
